import { Grid } from '@mui/material'
import React from 'react'
import CompleteHeader from '../components/complete-header'
import DiscountCompletePanel from '../components/discount-complete-panel'
import CurrentPlan from '../components/plan-details/current-plan'
import StepPageContainer from '../components/step-page-container'

const DiscountCompletePage = ({ discount }) => {
  return (
    <StepPageContainer>
      <Grid item xs={12}>
        <CompleteHeader title="You're all set - you have received your discount on your subscription" />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <DiscountCompletePanel discount={discount} />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <CurrentPlan />
      </Grid>
    </StepPageContainer>
  )
}

export default DiscountCompletePage
